export const applicationIdType = {
    rajasthan: "rajasthan",
    punjab: "punjab",
}

export const InstituteNames = {
    NMTI: "National Midwifery Training Institute",
    SMTI: "State Midwifery Training Institute."
}